import { createFileRoute } from "@tanstack/react-router";
import { HomePage } from "../../components/home/home-page";
import type { AppsTab } from "../../lib/api";
import { searchEnum, searchString } from "../../lib/search";

const TABS: readonly AppsTab[] = ["recent", "owned", "shared", "trash"];

interface HomeSearch {
  tab?: AppsTab;
  q?: string;
}

export const Route = createFileRoute("/_authed/")({
  validateSearch: (search: Record<string, unknown>): HomeSearch => {
    const out: HomeSearch = {};
    const tab = searchEnum(search.tab, TABS);
    const q = searchString(search.q);
    if (tab !== undefined && tab !== "recent") out.tab = tab;
    if (q !== undefined) out.q = q.slice(0, 100);
    return out;
  },
  component: HomeRoute,
});

function HomeRoute() {
  const { tab, q } = Route.useSearch();
  return <HomePage tab={tab ?? "recent"} q={q ?? ""} />;
}
